import { slicePrefix } from './special-match-list.constants';
import getSliceName from '@om-fe/core/utils/get-slice-name';
import { SpecialMatchListTopicModel, SPECIAL_MATCH_MULTI_AGGREGATOR, SPECIAL_MATCH_SINGLE_AGGREGATOR } from './special-match-list.constants';
import { BonusType } from '../../../match-list-group/match-list-special-header';

export function getSpecialMatchListSliceName(instanceId: string): string {
    return getSliceName(slicePrefix, instanceId);
}

export function getSpeciclMatchListTopic(bonusType: BonusType): SpecialMatchListTopicModel {
    const topic: string = bonusType === BonusType.Single ? SPECIAL_MATCH_SINGLE_AGGREGATOR : SPECIAL_MATCH_MULTI_AGGREGATOR;
    const eventLimit: number = 25;

    return {
        path: `${topic}/${eventLimit}`,
    }
}